module.exports = __webpack_public_path__ + "static/img/pexels-pixabay-373543.8fe824c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pexels-pixabay-373543.png
// module id = COCm
// module chunks = 0